/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

import filesize from 'file-size';

const specifications = Object.freeze({
    si: 'si',
    iec: 'iec',
    jedec: 'jedec'
});
/**
 * Convert file size to user friendly format
 * @param {number} bytes
 * @param {string} specification - converting specification. Supports 'si', 'iec', 'jedec'
 * @returns {string}
 */
export function convertSizeToReadableFormat(bytes, specification = 'si') {
    const defaultValue = bytes.toString();
    if(!specifications[specification]){
        return defaultValue;
    }
    if(bytes > convertingLimit(specification)){
        return defaultValue;
    }
    const { fixed, suffix } = filesize(bytes).calculate(specification);
    const number = fixed ? Number(fixed) : null;

    if(!number){
        return defaultValue;
    }
    return `${number} ${suffix}`;
}

function convertingLimit(specification){
    if(specification === specifications.si){
        const oneYottabyte = Math.pow(1000, 8);
        const maxYottabyte = 999;

        return Math.floor(maxYottabyte * oneYottabyte);
    }
    if(specification === specifications.iec){
        const oneYobibyte = Math.pow(1024, 8);
        const maxYobibyte = 999;

        return Math.floor(maxYobibyte * oneYobibyte);
    }
}
